import {
  HIDE_DUPLICATES,
  RESET_DUPLICATES_STATE,
  SET_DUPLICATE_PROPERTIES,
  SHOW_DUPLICATES,
  START_LOADING
} from '../actions/duplicates';

export default function (state = {}, action) {
  switch (action.type) {
  case HIDE_DUPLICATES:
    return { ...state, viewActive: false };
  case RESET_DUPLICATES_STATE:
    return { ...state, properties: [], propertyPage: 1 };
  case SET_DUPLICATE_PROPERTIES: {
    const { duplicates, page, pageSize, totalCount } = action;
    return {
      ...state,
      isLoading: false,
      properties: duplicates,
      propertyPage: page,
      propertyPageSize: pageSize,
      totalProperties: totalCount
    };
  }
  case SHOW_DUPLICATES:
    return { ...state, isLoading: true, viewActive: true };
  case START_LOADING:
    return { ...state, isLoading: true };
  default:
    return state;
  }
}
